import { call } from 'redux-saga/effects'
import { createAction } from 'redux-actions'

import { offline } from 'store/entities/offline/actions'
import { addToQueueWithWaiting } from 'store/entities/offline/saga/addToQueueWithWaiting'

/**
 * Helper for creating API request actions.
 * Example usage:
 * // actions.js
 * // returns actions userFromAPI.fetch(12), userFromAPI.fetchSuccess(payload: response), userFromAPI.fetchFail(error)
 * const userFromAPI = createRequestActions('USER/FETCH', id => ({
 *   request: {
 *     url: `/users/${id}`,
 *     method: 'GET',
 *   },
 * }))
 *
 * @param actionType - entity name with action (for example: "IDENTITY/FETCH", "IDENTITY/INSERT", "PROTRACKS/FETCH", ...)
 * @param callback func : params => ({
 *          url: string, // string for creating request
 *          method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
 *          data?: object,
 *        }) - data for making request
 * @returns { [entity] } = { [entity]: { [entity].[action], [entity].[action]Success, [entity].[action]Fail } }
 */
export const createRequestActions = (actionType, callback) => {
  const requestAction = params => offline.request(actionType, callback(params))
  requestAction.toString = () => actionType
  requestAction.call = params => call(addToQueueWithWaiting, { payload: { actionType, params: callback(params) } })
  requestAction.success = createAction(`${actionType}_SUCCESS`)
  requestAction.fail = createAction(`${actionType}_FAIL`)
  return requestAction
}

/**
 * Full usage example:
 *
 * import { createRequestActions as request } from 'store/actionCreators'
 *
 * const identity = {}
 * identity.data = request('IDENTITY_DATA/FETCH', id => ({ url: `/user/${id}` }))
 * export identity
 */
